// extracted by mini-css-extract-plugin
export var chevronIcon = "_75-2";
export var teamName = "_75-1";
export var teamSwitcherButton = "_75-0";